<h2 class="mb-4 text-primary" *ngIf="!id" i18n="Create post label">Create post</h2>
<h2 class="mb-4 text-primary" *ngIf="id" i18n="Update post label">Update post</h2>
<div class="row">  
  <app-news-form [editedPost]="post$ | async" 
    (newsSubmit)="updatePost($event)"></app-news-form>  
  <app-error-alert title="Could not submit the post" i18n-title="News post submit error alert"
    [errors]="submitErrors"></app-error-alert>
</div>
